import Card from "../Card";

const Customer = () => {
  return (
    <div className="flex gap-10 flex-wrap">
      <Card />
      <Card />
    </div>
  );
};
export default Customer;
